import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CountryListItem,
  SelectedCountry,
  StepperData,
} from "../../types/common";

type CustomerJourneyDetails = {
  stepperConfig: Array<StepperData>;
  stepData: StepperData;
  selectedCountry?: SelectedCountry;
  countryList: Array<CountryListItem>;
  pageText: any;
  pageLanguages: any;
  apiloading: false;
  toastData: {
    message: string;
    type: string;
    open: boolean;
  };
};

const initialState: CustomerJourneyDetails = {
  stepData: {
    label: "Select Location",
    value: "location",
    stepNumber: 1,
    selected: true,
    completed: false,
    showArrow: true,
  },
  stepperConfig: [],
  selectedCountry: undefined,
  countryList: [],
  pageText: null,
  pageLanguages: [],
  apiloading: false,
  toastData: {
    message: "",
    type: "",
    open: false,
  },
};
const customerJourneyDetails = createSlice({
  name: "customerJourney",
  initialState,
  reducers: {
    setStepData: (state, action) => {
      state.stepData = action.payload.data;
    },
    setStepperConfig: (state, action) => {
      state.stepperConfig = action.payload.data;
    },
    setSelectedCountry: (
      state,
      action: PayloadAction<{ country?: SelectedCountry }>
    ) => {
      state.selectedCountry = action.payload.country;
    },
    setCountryList: (
      state,
      action: PayloadAction<{ list: CountryListItem[] }>
    ) => {
      state.countryList = action.payload.list;
    },
    setJourneyText: (state, action) => {
      state.pageText = action.payload.data?.siteMetadata;
      state.pageLanguages = action.payload.data?.languages;
    },
    setLoading: (state, action) => {
      state.apiloading = action.payload.loading;
    },
    setToastData: (state, action) => {
      state.toastData = action.payload.toastData;
    },
  },
});

export const {
  setStepData,
  setStepperConfig,
  setSelectedCountry,
  setCountryList,
  setJourneyText,
  setLoading,
  setToastData,
} = customerJourneyDetails.actions;
export default customerJourneyDetails.reducer;
